import { $host } from "./index";

export const saveRatingComment = async (id, adminComment) => {
  const { data } = await $host.post("web/reviews", { id, adminComment });
  return data;
};

export const fetchRatings = async (page = 1, size = 10, rating, branch) => {
  const params = {
    page: page - 1,
    size,
  };

  if (rating !== undefined && rating !== null && rating !== "") {
    params.review = rating;
  }
  if (branch !== undefined && branch !== null && branch !== "") {
    params.branch = branch;
  }

  const { data } = await $host.get("web/reviews", { params });
  return data;
};

export const fetchRatingById = async (id) => {
  const { data } = await $host.get(`web/reviews/${id}`);
  return data;
};
